import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/Address',
    name: 'Address',
    component: () => import('../views/Address.vue')
  },
  {
    path: '/Block',
    name: 'Block',
    component: () => import('../views/Block.vue')
  }, 
  {
    path: '/BlockInfo',
    name: 'BlockInfo',
    component: () => import('../views/BlockInfo.vue')
  },
  {
    path: '/Transaction',
    name: 'Transaction',
    component: () => import('../views/Transaction.vue')
  },
  {
    path: '/TransactionInfo',
    name: 'TransactionInfo',
    component: () => import('../views/TransactionInfo.vue')
  },
  {
    path: '/Burn',
    name: 'Burn',
    component: () => import('../views/Burn.vue')
  },
  {
    path: '/Burning',
    name: 'Burning',
    component: () => import('../views/Burning.vue')
  },
  {
    path: '/UCenter',
    name: 'UCenter',
    component: () => import('../views/UCenter.vue')
  },
  {
    path: '/Wallet',
    name: 'Wallet',
    component: () => import('../views/Wallet.vue')
  },
  {
    path: '/WalletImport',
    name: 'WalletImport',
    component: () => import('../views/WalletImport.vue')
  },
  {
    path: '/WalletMine',
    name: 'WalletMine',
    component: () => import('../views/WalletMine.vue')
  },
  {
    path: '/WalletTran',
    name: 'WalletTran',
    component: () => import('../views/WalletTran.vue')
  },
  {
    path: '/WalletFrozen',
    name: 'WalletFrozen',
    component: () => import('../views/WalletFrozen.vue')
  },
  {
    path: '/WalletFreed',
    name: 'WalletFreed',
    component: () => import('../views/WalletFreed.vue')
  },
  {
    path: '/WalletTeam',
    name: 'WalletTeam',
    component: () => import('../views/WalletTeam.vue')
  },
  {
    path: '/Ceshi',
    name: 'Ceshi',
    component: () => import('../views/Ceshi.vue')
  },
]
 
const router = new VueRouter({
  routes
}) 

export default router

